import React from 'react';
import upArrow from "assets/images/icons/collapse-up-arrow.svg";
import downArrow from "assets/images/icons/collapse-down-arrow.svg";

export const CourseSubGroupCard = ({ name, list, isOpen, setIsOpen, handleCourseSubGroup }) => {

    return (
        <section className="main-group-section">
            <div
                className="main-group-header"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="main-group-header-left">
                    <div className="main-group-main-number">
                        1
                    </div>

                    <h2>{name}</h2>
                </div>

                <div className="main-group-collapse-icon">
                    <img src={isOpen ? upArrow : downArrow} alt="" />

                </div>
            </div>

            {isOpen && (
                <div className="main-group-items">
                    {list.map((item, index) => (
                        <div
                            key={item.id}
                            className="main-group-item"
                            onClick={() => handleCourseSubGroup(item)}
                        >
                            <div className="main-group-item-left">
                                <div className="main-group-item-number">
                                    {index + 1}
                                </div>

                                <div className="main-group-item-content">
                                    <h3>{item.name}</h3>

                                    <span>
                                        {item.numberOfCourses} Tasks
                                    </span>
                                </div>
                            </div>

                            <div className="main-group-item-right">
                                <div className="main-group-arrow">
                                    <span>›</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </section>
    )
}
